module.exports = __webpack_public_path__ + "static/Sedgwick-Ave-d833edc881fe87bae04dcef6b826760a.woff";